import { LockClosedIcon, SparklesIcon } from '@heroicons/react/24/solid'

import { CHAT } from '../../content'
import { anim, prog } from '../../motion'
import { Avatar, Typed } from '../../primitives'
import { Words } from '../kit'

// Ein Satz schreibt sich ins Bild, dann erklärt der Assistent Lenas Ergebnis
export default function CinAi() {
  return (
    <div className='cin-full'>
      <div
        className='cin-ai-statement'
        style={{
          ...prog([0.36, 0.46]),
          transform:
            'translate(-50%, -50%) translateY(calc(var(--p) * -30cqh)) scale(calc(1 - 0.45 * var(--p)))'
        }}
      >
        <Words text='Die KI rechnet nicht.' at={[0.02, 0.16]} />
        <br />
        <Words text='Sie erklärt.' at={[0.16, 0.28]} className='cin-accent' />
      </div>

      <div
        className='cin-chat'
        style={anim({ at: [0.42, 0.5], y: 80, s: 0.94 })}
      >
        <div className='cin-chat__head'>
          <span className='cin-chat__logo'>
            <SparklesIcon width={18} height={18} color='#fff' />
          </span>
          <span>Aivy Assistent</span>
          <span className='cin-chat__tag'>Hilfsmittel</span>
        </div>
        <div
          className='cin-chat__me'
          style={anim({ at: [0.48, 0.53], x: 30, y: 0 })}
        >
          {CHAT.q1}
          <Avatar initials='M' color='blue' size={28} />
        </div>
        <div
          className='cin-chat__ai'
          style={anim({ at: [0.53, 0.57], x: -30, y: 0 })}
        >
          <Typed text={CHAT.a1} at={[0.55, 0.72]} />
        </div>
        <div
          className='cin-chat__lock'
          style={anim({ at: [0.76, 0.84], y: 20 })}
        >
          <LockClosedIcon width={16} height={16} />
          Die Passung bleibt regelbasiert. Die KI erklärt sie nur.
        </div>
      </div>
    </div>
  )
}
